export default __webpack_public_path__ + "static/media/bacalla.2c86bf9e.jpg";